import { createBrowserRouter, Navigate } from "react-router-dom";
import { UnAuthAppLayout } from "views/layouts/UnAuthAppLayout";
import { Login } from "./Login";
import { UserActivation } from "./UserActivation";

export const unAuthRouter = createBrowserRouter([
    {
        element: <UnAuthAppLayout/>,
        children: [
            {
                path: '/',
                element: <Login/>
            },
            {
                path: '/userAuth',
                element: <UserActivation/>
            },
            {
                path: '*',
                element: <Navigate to="/" replace />
            }
        ]
    }
])